import _ from 'lodash'
import { getDepartments } from '../../../menu-services/departments-service'
import { getAllCategories } from '../../../menu-services/categories-service'
import { getAllItems } from '../../../menu-services/items-service'
import { getModifierCategories, getModifierItems } from '../../../menu-services/modifiers-service'

export function cleanRequirementItems (requirement, menuBlob) {
  if (!_.has(requirement, 'items')) return

  cleanDepartmentItems(requirement.items, menuBlob)
  cleanModifiers(requirement.items, menuBlob)
  cleanMessages(requirement.items, menuBlob)
}

function cleanDepartmentItems (requirementItems, menuBlob) {
  const availableDepartments = getDepartments(menuBlob).map(it => it.id)
  const availableCategories = getAllCategories(menuBlob).map(it => it.id)
  const availableItems = getAllItems(menuBlob).map(it => it.id)

  requirementItems.items = requirementItems.items
    .filter(it => availableDepartments.includes(it.departmentId))

  for (const department of requirementItems.items) {
    department.categories = department.categories.filter(it => availableCategories.includes(it.id))
    department.categories = _.uniqBy(department.categories, 'id')

    department.items = department.items.filter(it => availableItems.includes(it.id))
    department.items = _.uniqBy(department.items, 'id')
  }

  cleanOrder(requirementItems, it => it.type !== 'ITEM' || availableItems.includes(it.id))
}

function cleanModifiers (requirementItems, menuBlob) {
  const availableCategories = getModifierCategories(menuBlob).map(it => it.id)
  const availableItems = getModifierItems(menuBlob).map(it => it.id)

  requirementItems.modifiers.categories = requirementItems.modifiers.categories
    .filter(it => availableCategories.includes(it))
  requirementItems.modifiers.categories = _.uniq(requirementItems.modifiers.categories)

  requirementItems.modifiers.items = requirementItems.modifiers.items
    .filter(it => availableItems.includes(it.id))
  requirementItems.modifiers.items = _.uniqBy(requirementItems.modifiers.items, 'id')

  cleanOrder(requirementItems, it => it.type !== 'MODIFIER' || availableItems.includes(it.id))
}

function cleanMessages (requirementItems, menuBlob) {
  const availableMessages = _.get(menuBlob, 'messages', []).map(it => it.id)
  requirementItems.messages = requirementItems.messages.filter(it => availableMessages.includes(it))
  cleanOrder(requirementItems, it => it.type !== 'MESSAGE' || availableMessages.includes(it.id))
}

function cleanOrder (requirementItems, filter) {
  requirementItems.order = requirementItems.order
    .filter(filter)
    .sort((a, b) => a.order - b.order)
    .map((order => next => {
      next.order = order++
      return next
    })(0))
}

export default {
  cleanDepartmentItems,
  cleanModifiers,
  cleanMessages
}
